//
//  background-video.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue, Component } from 'vue-property-decorator';
import EventBus from '@/utils/event-bus';
import lottie from 'lottie-web';
import { mapState } from 'vuex';

@Component({
    computed: {
        ...mapState('dataModule', ['backgroundUrl']),
    },
})
export default class BackgroundVideo extends Vue {

    private backgroundUrl!: string;

    private get url(): string {

        const url: string = this.backgroundUrl;

        return `/image/background/${url}/${url}`;

    }

    private get backgroundVideo(): HTMLVideoElement {

        return this.$refs.backgroundVideo as HTMLVideoElement;

    }

    private get overlay(): HTMLVideoElement {

        return this.$refs.overlay as HTMLVideoElement;

    }

    private mounted(): void {

        this.backgroundVideo.onloadeddata = () => {

            setTimeout(() => {

                this.backgroundVideo.play();
                setTimeout(() => EventBus.$emit('background-video-loaded'), 100);

            }, 400);

        };

        // Show poster if video loading error.
        this.backgroundVideo.addEventListener('error', () => {

            EventBus.$emit('background-video-loaded');

        });

        // Show poster if video takes too long to load
        setTimeout(() => {

            EventBus.$emit('background-video-loaded');

        }, 6000);

        this.setLoadingAnimation();

    }

    /*
     * Change the background video if store has changed.
     */
    private updated() {

        this.overlay.style.opacity = '1';

        setTimeout(() => {

            this.backgroundVideo.load();

            this.backgroundVideo.onloadeddata = () => {

                this.backgroundVideo.play();
                this.hideOverlay();

            };

        }, 400);

        // Show poster if video loading error.
        this.backgroundVideo.addEventListener('error', this.hideOverlay);

        // Show poster if video takes too long to load
        setTimeout(this.hideOverlay, 6000);

    }

    private destroyed(): void {

        this.backgroundVideo.removeEventListener('error', this.hideOverlay);

    }

    private hideOverlay(): void {

        this.overlay.style.opacity = '0';

    }

    /*
     * Load the lottie loading animation.
     */
    private setLoadingAnimation(): void {

        lottie.loadAnimation({
            container: this.$refs.loader as HTMLElement, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/image/lottie/loader.json', // the path to the animation json
        });

    }

}
